const getModuleName = path => {
  const [, module] = path.split("/");

  return (module === "cad" ? "adm" : module) || null;
};

export default {
  getModuleName
};
